import type { StationState } from "@station-keeping/sim";
import { useSyncExternalStore } from "react";
import type { GameEngine } from "./engine";

/**
 * Le moteur en cours, partagé par le rendu et l'interface. Il change à l'ouverture d'une session (ou à la
 * reprise sur cet appareil) ; les composants suivent l'état par `useStation()`.
 */
let current: GameEngine | null = null;
const listeners = new Set<() => void>();

export function setEngine(engine: GameEngine | null): void {
  current?.stop();
  current = engine;
  engine?.start();
  for (const listener of listeners) listener();
}

export function getEngine(): GameEngine | null {
  return current;
}

function subscribeEngine(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useEngine(): GameEngine | null {
  return useSyncExternalStore(subscribeEngine, getEngine);
}

const noop = () => () => undefined;

/** État de la station, re-rendu à chaque pas ou action (une fois par seconde en jeu normal). */
export function useStation(): StationState | null {
  const engine = useEngine();
  useSyncExternalStore(engine ? engine.subscribe : noop, engine ? engine.getVersion : () => 0);
  return engine?.state ?? null;
}
